import _typeof from "@babel/runtime/helpers/typeof";

/**
 * This source code is quoted from rc-util.
 * homepage: https://github.com/react-component/util
 */
import React from 'react';
import createChainableTypeChecker from './utils/createChainableTypeChecker';

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  var propType = _typeof(propValue);

  if ( /*#__PURE__*/React.isValidElement(propValue)) {
    return new Error("Invalid ".concat(location, " `").concat(propFullName, "` of type ReactElement ") + "supplied to `".concat(componentName, "`, expected a ReactComponent or a ") + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(propFullName, "` of value `").concat(propValue, "` ") + "supplied to `".concat(componentName, "`, expected a ReactComponent or a ") + 'DOMElement.');
  }

  return null;
}

export default createChainableTypeChecker(validate);


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/componentOrElement.js